import React from "react";
import { formatValue } from "react-currency-input-field";

export const formatCurrencyInputValue = (value) => {
  if (!value) {
    return "";
  }

  const formattedValue = value.replaceAll(".", "").replaceAll(",", "");

  const formatted = formatValue({
    value: formattedValue,
    groupSeparator: ".",
    decimalSeparator: ",",
  });

  return formatted;
};

export const getMinutesStatusOptions = (ignoreStatus = []) => {
  const language = localStorage.getItem("i18nextLng");

  if (language === "pt") {
    return [
      { id: "E", name: "Em Elaboração" },
      { id: "R", name: "Em Revisão" },
      { id: "EA", name: "Em Assinatura" },
      { id: "RC", name: "Revisão Chairperson" },
      { id: "PR", name: "Em Revisão Participantes" },
      { id: "NI", name: "Não Iniciada" },
      { id: "C", name: "Concluído" },
    ].filter((status) => !ignoreStatus.includes(status.id));
  } else if (language === "en") {
    return [
      { id: "E", name: "In progress" },
      { id: "R", name: "In revision" },
      { id: "EA", name: "Em Assinatura" },
      { id: "PR", name: "Participants Review" },
      { id: "NI", name: "Non Initialized" },
      { id: "RC", name: "Chairperson Review" },
      { id: "C", name: "Concluded" },
    ].filter((status) => !ignoreStatus.includes(status.id));
  } else if (language === "es") {
    return [
      { id: "E", name: "En Curso" },
      { id: "R", name: "En revisión" },
      { id: "EA", name: "Em Assinatura" },
      { id: "PR", name: "Revisión del participants" },
      { id: "NI", name: "No Iniciado" },
      { id: "RC", name: "Revisión del presidente" },
      { id: "C", name: "Terminado" },
    ].filter((status) => !ignoreStatus.includes(status.id));
  }
};

export const getInSignatureMinuteStatus = () => {
  const language = localStorage.getItem("i18nextLng");

  const statusMap = {
    pt: { id: "R", name: "Em Revisão" },
    en: { id: "R", name: "In revision" },
    es: { id: "R", name: "En revisión" },
  };

  return [statusMap[language] || statusMap["pt"]];
};

export const getFormattedMeetStatus = (statusCode) => {
  const language = localStorage.getItem("i18nextLng");

  if (language === "pt") {
    if (statusCode === "Aberta") {
      return (
        <span style={{ fontWeight: "bold", color: "#6FA5F9" }}>
          {statusCode}
        </span>
      );
    }

    if (statusCode === "Cancelada") {
      return (
        <span style={{ fontWeight: "bold", color: "#B90C78" }}>
          {statusCode}
        </span>
      );
    }

    if (statusCode === "Confirmada") {
      return (
        <span style={{ fontWeight: "bold", color: "#64B246" }}>
          {statusCode}
        </span>
      );
    }

    if (statusCode === "Concluído") {
      return (
        <span style={{ fontWeight: "bold", color: "#F5D700" }}>
          {statusCode}
        </span>
      );
    }
  } else if (language === "en") {
    if (statusCode === "Open") {
      return (
        <span style={{ fontWeight: "bold", color: "#6FA5F9" }}>
          {statusCode}
        </span>
      );
    }

    if (statusCode === "Canceled") {
      return (
        <span style={{ fontWeight: "bold", color: "#B90C78" }}>
          {statusCode}
        </span>
      );
    }

    if (statusCode === "Confirmed") {
      return (
        <span style={{ fontWeight: "bold", color: "#64B246" }}>
          {statusCode}
        </span>
      );
    }

    if (statusCode === "Concluded") {
      return (
        <span style={{ fontWeight: "bold", color: "#F5D700" }}>
          {statusCode}
        </span>
      );
    }
  } else {
    if (statusCode === "Abierto") {
      return (
        <span style={{ fontWeight: "bold", color: "#6FA5F9" }}>
          {statusCode}
        </span>
      );
    }

    if (statusCode === "Cancelado") {
      return (
        <span style={{ fontWeight: "bold", color: "#B90C78" }}>
          {statusCode}
        </span>
      );
    }

    if (statusCode === "Confirmado") {
      return (
        <span style={{ fontWeight: "bold", color: "#64B246" }}>
          {statusCode}
        </span>
      );
    }

    if (statusCode === "Concluido") {
      return (
        <span style={{ fontWeight: "bold", color: "#F5D700" }}>
          {statusCode}
        </span>
      );
    }
  }
};

export const getMeetStatus = (statusCode) => {
  const language = localStorage.getItem("i18nextLng");

  if (language === "pt") {
    switch (statusCode) {
      case "O":
        return (
          <span style={{ fontWeight: "bold", color: "#97CA83" }}>
            Em Aberto
          </span>
        );
      case "S":
        return (
          <span style={{ fontWeight: "bold", color: "#465eb6" }}>Agendada</span>
        );
      case "C":
        return (
          <span style={{ fontWeight: "bold", color: "#E11021" }}>
            Cancelada
          </span>
        );
      case "CF":
        return (
          <span style={{ fontWeight: "bold", color: "#F5D700" }}>
            Confirmada
          </span>
        );
      case "CC":
        return (
          <span style={{ fontWeight: "bold", color: "#64B246" }}>
            Concluído
          </span>
        );
      case "UD":
        return (
          <span style={{ fontWeight: "bold", color: "#B90C78" }}>
            Em Discussão
          </span>
        );
    }
  } else if (language === "en") {
    switch (statusCode) {
      case "O":
        return (
          <span style={{ fontWeight: "bold", color: "#97CA83" }}>
            In progres
          </span>
        );
      case "S":
        return (
          <span style={{ fontWeight: "bold", color: "#465eb6" }}>
            Scheduled
          </span>
        );
      case "C":
        return (
          <span style={{ fontWeight: "bold", color: "#E11021" }}>Canceled</span>
        );
      case "CF":
        return (
          <span style={{ fontWeight: "bold", color: "#F5D700" }}>
            Confirmed
          </span>
        );
      case "CC":
        return (
          <span style={{ fontWeight: "bold", color: "#64B246" }}>
            Concluded
          </span>
        );
      case "UD":
        return (
          <span style={{ fontWeight: "bold", color: "#B90C78" }}>
            In Discouss
          </span>
        );
    }
  } else if (language === "es") {
    switch (statusCode) {
      case "O":
        return (
          <span style={{ fontWeight: "bold", color: "#97CA83" }}>
            En abierto
          </span>
        );
      case "S":
        return (
          <span style={{ fontWeight: "bold", color: "#465eb6" }}>
            Programado
          </span>
        );
      case "C":
        return (
          <span style={{ fontWeight: "bold", color: "#E11021" }}>
            Cancelado
          </span>
        );
      case "CF":
        return (
          <span style={{ fontWeight: "bold", color: "#F5D700" }}>
            Confirmada
          </span>
        );
      case "CC":
        return (
          <span style={{ fontWeight: "bold", color: "#64B246" }}>
            Concluido
          </span>
        );
      case "UD":
        return (
          <span style={{ fontWeight: "bold", color: "#B90C78" }}>
            En Discutir
          </span>
        );
    }
  }
};

export const getMinutesStatus = (statusCode, language) => {
  if (language === "pt") {
    switch (statusCode) {
      case "E":
        return (
          <span style={{ fontWeight: "bold", color: "#97CA83" }}>
            Em Elaboração
          </span>
        );
      case "R":
        return (
          <span style={{ fontWeight: "bold", color: "#465eb6" }}>
            Em Revisão
          </span>
        );
      case "VG":
        return (
          <span style={{ fontWeight: "bold", color: "#B90C78" }}>
            Validado Governança Compliance
          </span>
        );
      case "RC":
        return (
          <span style={{ fontWeight: "bold", color: "#F5D700" }}>
            Revisão Chairperson
          </span>
        );
      case "PR":
        return (
          <span style={{ fontWeight: "bold", color: "#6646b2" }}>
            Em Revisão Participantes
          </span>
        );
      case "C":
        return (
          <span style={{ fontWeight: "bold", color: "#64B246" }}>
            Concluído
          </span>
        );
      case "NI":
        return (
          <span style={{ fontWeight: "bold", color: "#E11021" }}>
            Não Iniciada
          </span>
        );
      case "EA":
        return (
          <span style={{ fontWeight: "bold", color: "#98e110" }}>
            Aguardando Assinaturas
          </span>
        );
      case "PR":
        return (
          <span style={{ fontWeight: "bold", color: "#edce83" }}>
            Revisão Participantes
          </span>
        );
    }
  } else if (language === "en") {
    switch (statusCode) {
      case "E":
        return (
          <span style={{ fontWeight: "bold", color: "#97CA83" }}>
            In progress
          </span>
        );
      case "R":
        return (
          <span style={{ fontWeight: "bold", color: "#465eb6" }}>
            In revision
          </span>
        );
      case "VG":
        return (
          <span style={{ fontWeight: "bold", color: "#B90C78" }}>
            Validated Governance Compliance
          </span>
        );
      case "RC":
        return (
          <span style={{ fontWeight: "bold", color: "#F5D700" }}>
            Chairperson Review
          </span>
        );
      case "C":
        return (
          <span style={{ fontWeight: "bold", color: "#64B246" }}>
            Concluded
          </span>
        );
      case "NI":
        return (
          <span style={{ fontWeight: "bold", color: "#E11021" }}>
            Non Initialized
          </span>
        );
      case "EA":
        return (
          <span style={{ fontWeight: "bold", color: "#98e110" }}>
            Waiting for Signatures
          </span>
        );
        case "PR":
          return (
            <span style={{ fontWeight: "bold", color: "#edce83" }}>
              Participants Review
            </span>
          );
    }
  } else if (language === "es") {
    switch (statusCode) {
      case "E":
        return (
          <span style={{ fontWeight: "bold", color: "#97CA83" }}>En Curso</span>
        );
      case "R":
        return (
          <span style={{ fontWeight: "bold", color: "#465eb6" }}>
            En revisión
          </span>
        );
      case "VG":
        return (
          <span style={{ fontWeight: "bold", color: "#B90C78" }}>
            Cumplimiento de Gobernanza Validado
          </span>
        );
      case "RC":
        return (
          <span style={{ fontWeight: "bold", color: "#F5D700" }}>
            Revisión del presidente
          </span>
        );
      case "C":
        return (
          <span style={{ fontWeight: "bold", color: "#64B246" }}>
            Concluido
          </span>
        );
      case "NI":
        return (
          <span style={{ fontWeight: "bold", color: "#E11021" }}>
            No Inicializado
          </span>
        );
      case "EA":
        return (
          <span style={{ fontWeight: "bold", color: "#98e110" }}>
            Esperando Firmas
          </span>
        );
      case "PR":
        return (
          <span style={{ fontWeight: "bold", color: "#edce83" }}>
            Revisión de los participantes
          </span>
        );
    }
  }
};

export const slotStatus = (statusCode) => {
  const language = localStorage.getItem("i18nextLng");

  const allStatus = {
    pt: {
      nv: "Não vinculado a reunião",
      A: "Ativo",
      I: "Inativo",
      C: "Concluído",
      F: "Confirmado",
      P: "Planejado",
      V: "Em aprovação",
      D: "Em Disscussão",
    },
    en: {
      nv: "Not linked to meeting",
      A: "Active",
      I: "Inactive",
      C: "Concluded",
      F: "Confirmed",
      P: "Planedd",
      V: "In approval",
      D: "In Discouss",
    },
    es: {
      nv: "No vinculado a la reunión",
      A: "Activo",
      I: "Inactivo",
      C: "Completado",
      F: "Confirmado",
      P: "Planeado",
      V: "Em aprobación",
      D: "En Discutir",
    },
  };

  if (language === "pt") {
    return allStatus.pt[String(statusCode)];
  }

  if (language === "en") {
    return allStatus.en[String(statusCode)];
  }

  if (language === "es") {
    return allStatus.es[String(statusCode)];
  }
};

export const getSlotStatus = (statusCode, language) => {
  if (language === "pt") {
    switch (statusCode) {
      case "A":
        return "Ativo";
      case "I":
        return "Inativo";
      case "C":
        return "Concluído";
      case "F":
        return "Confirmado";
      case "P":
        return "Planejado";
    }
  } else if (language === "en") {
    switch (statusCode) {
      case "A":
        return "Active";
      case "I":
        return "Inactive";
      case "C":
        return "Concluded";
      case "F":
        return "Confirmed";
      case "P":
        return "Planedd";
    }
  } else if (language === "es") {
    switch (statusCode) {
      case "A":
        return "Activo";
      case "I":
        return "Inactivo";
      case "C":
        return "Completado";
      case "F":
        return "Confirmado";
      case "P":
        return "Planeado";
    }
  }
};

export const actionsStatusOptions = (language) => {
  if (language === "pt") {
    return [
      { id: "L", name: "Em Andamento" },
      { id: "R", name: "Rotina" },
      { id: "C", name: "Cancelada" },
      { id: "AT", name: "Atrasada" },
      { id: "CO", name: "Concluída" },
      { id: "NI", name: "Não Iniciada" },
    ];
  } else if (language === "en") {
    return [
      { id: "L", name: "In Progress" },
      { id: "R", name: "Routine" },
      { id: "C", name: "Canceled" },
      { id: "AT", name: "Late" },
      { id: "CO", name: "Concluded" },
      { id: "NI", name: "Non Initialized" },
    ];
  } else {
    return [
      { id: "L", name: "In Progreso" },
      { id: "R", name: "Rutina" },
      { id: "C", name: "Cancelado" },
      { id: "AT", name: "Tarde" },
      { id: "CO", name: "Concluido" },
      { id: "NI", name: "No Iniciado" },
    ];
  }
};

export const getFormattedActionsStatus = (statusCode, t) => {
  switch (statusCode) {
    case "L":
      return (
        <span style={{ fontWeight: "bold", color: "#97CA83" }}>
          {t("menu.actions.actionStatus.L")}
        </span>
      );
    case "R":
      return (
        <span style={{ fontWeight: "bold", color: "#6fa5f9" }}>
          {t("menu.actions.actionStatus.R")}
        </span>
      );
    case "C":
      return (
        <span style={{ fontWeight: "bold", color: "#E11021" }}>
          {t("menu.actions.actionStatus.C")}
        </span>
      );
    case "AT":
      return (
        <span style={{ fontWeight: "bold", color: "#465eb6" }}>
          {t("menu.actions.actionStatus.AT")}
        </span>
      );
    case "CO":
      return (
        <span style={{ fontWeight: "bold", color: "#64b246" }}>
          {t("menu.actions.actionStatus.CO")}
        </span>
      );
    case "NI":
      return (
        <span style={{ fontWeight: "bold", color: "#F5D700" }}>
          {t("menu.actions.actionStatus.NI")}
        </span>
      );
  }
};

export const getChairPersonsValidations = () => {
  const language = localStorage.getItem("i18nextLng");

  switch (language) {
    case "pt":
      return [
        { name: "Validado", id: "v" },
        { name: "Não Validado", id: "nv" },
      ];
    case "en":
      return [
        { name: "Validated", id: "v" },
        { name: "Non Validated", id: "nv" },
      ];
    case "es":
      return [
        { name: "Validado", id: "v" },
        { name: "No Validado", id: "nv" },
      ];
  }
};

export const fileTypesOptions = () => {
  const language = localStorage.getItem("i18nextLng");

  switch (language) {
    case "pt":
      return [
        { name: "Palavra chave", id: "keyWord" },
        { name: "Comitê", id: "committee" },
        { name: "Tipo de arquivo", id: "type" },
      ];
    case "us":
      return [
        { name: "Key word", id: "keyWord" },
        { name: "Committee", id: "committee" },
        { name: "File Type", id: "type" },
      ];
    case "es":
      return [
        { name: "Palabra clave", id: "keyWord" },
        { name: "Comité", id: "committee" },
        { name: "Tipo de archivo", id: "type" },
      ];
  }
};

export const checkAccess = (userAccess, feature) => {
  if (!userAccess) {
    return false;
  }

  return !!userAccess[feature];
};

export const getCurrencySymbol = (currency) => {
  switch (String(currency).toUpperCase()) {
    case "BRL":
      return "R$";
    case "GBP":
      return "£";
    case "EUR":
      return "€";
    case "USD":
      return "US$";
    default:
      return "US$";
  }
};
